import { render, staticRenderFns } from "./MyComments.vue?vue&type=template&id=c7114e8a&scoped=true&"
import script from "./MyComments.vue?vue&type=script&lang=js&"
export * from "./MyComments.vue?vue&type=script&lang=js&"
import style0 from "./MyComments.vue?vue&type=style&index=0&id=c7114e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7114e8a",
  null
  
)

export default component.exports